function safeReplace(
  a: string | undefined,
  search: RegExp,
  replaceValue: string,
) {
  if (a === undefined) {
    return 'undefined';
  }
  return a.replace(search, replaceValue);
}

export function joinURL(...args: string[]): string {
  let url = args[0];
  for (let i = 1; i < args.length; ++i) {
    url = safeReplace(url, /\/$/, '') + '/' + safeReplace(args[i], /^\//, '');
  }
  return url;
}
